import { Box, Typography } from "@mui/material";

import { AdjustmentHistoryGrid } from "components/clients/strategy/AdjustmentHistoryGrid";
import { BucketAsset } from "features/trading/buckets";
import { OptionTypeEnum } from "helpers/types";

interface BucketMemberHistoryPanelProps {
  accountId: number;
  member: BucketAsset;
}

/**
 * AccountHistory for one bucket pair — the SAME grid as the strategy tab
 * (TRADE AMOUNT / PORTFOLIO views, inline editing, generate buttons).
 * Buckets are CP-only: one combined trade-amount chain per pair (calls +
 * puts, adjusted roots included), so everything here — the query, new
 * rows, coverage generation — uses option_type CP. The manual-mode switch
 * stays hidden (it lives on AccountStrategy).
 */
export const BucketMemberHistoryPanel = ({
  accountId,
  member,
}: BucketMemberHistoryPanelProps) => (
  <Box display="flex" flexDirection="column" gap={1}>
    <Typography variant="h6" color="primary.main" paddingX={0.5}>
      Account history — {member.symbol}
      <Typography component="span" color="text.secondary" marginLeft={1}>
        {member.asset__name}
      </Typography>
    </Typography>
    <AdjustmentHistoryGrid
      accountId={accountId}
      assetId={member.asset}
      optionType={OptionTypeEnum.CALL_AND_PUT}
      canCreate
    />
  </Box>
);
